import './Control.scss';
import Component from './Control.js';
export default Component;
